import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';

import { DropdownSelectComponent } from './dropdown-select.component';
import { GlobalPipesModule } from '@app/pipes/global-pipes.module';
import { DropDownFieldDsComponent } from '@design-system/components/templates/drop-down-field/drop-down-field.component';
import { DropDownListDsComponent } from '@design-system/components/templates/drop-down-list/drop-down-list.component';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';

@NgModule({
  declarations: [
    DropdownSelectComponent
  ],
  exports: [
    DropdownSelectComponent
  ],
  imports: [
    CommonModule,
    TranslocoModule,
    GlobalPipesModule,
    DropDownFieldDsComponent,
    DropDownListDsComponent,
    TypographyDsComponent,
  ]
})
export class DropdownSelectModule { }
